import AdditionalInventoryModal from './AdditionalInventoryModal';

export default AdditionalInventoryModal;
